<!--
 * @Author: 欲买桂花同载酒，终不似，少年游。
 * @Date: 2025-12-22 19:03:42
 * @LastEditors: 欲买桂花同载酒，终不似，少年游。
 * @LastEditTime: 2026-09-18 12:32:08
 * @FilePath: \fly-web\src\components\Layout\FooterBar.vue
 * @filePurpose: 
-->
<template>
  <footer class="footer">
    <div class="control">
      <p>
        主办：中国人民解放军海军招收飞行学员工作办公室
        <a
          style="color: #f2f2f2; user-select: none"
          href="https://beian.miit.gov.cn"
          target="_blank"
        >
          京ICP备19048269号-1
        </a>
      </p>
      <p style="margin-top: 0.1rem">
        本网站刊登的所有新闻信息和专题专栏资料，均为海军招飞网版权所有，未经协议授权，禁止下载使用
      </p>
    </div>
  </footer>
</template>

<script setup></script>

<style lang="scss" scoped>
.footer {
  color: #f2f2f2;
  background: #072c63;
  padding-top: 0.25rem;
  padding-bottom: 0.1rem;
  font-size: 0.12rem;
  .control {
    width: 100%;
    text-align: center;
    font-size: 0.16rem;
  }
}
p span {
  display: inline-block;
  margin-right: 0.16rem;
  line-height: 0.2rem;
}
.address {
  margin-top: 0.16rem;
}
.weixin {
  margin-left: 18%;
  .wx-code {
    width: 0.94rem;
  }
  .wx-text {
    width: 0.74rem;
    margin-top: 0.1rem;
  }
  img {
    display: block;
  }
}
.link-list {
  span {
    cursor: pointer;
    &:hover {
      color: #6dafff;
      text-decoration: underline;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/variable.scss";
/* 平板或小屏设备 */
@media (max-width: $mobile-width) {
  .control {
    width: auto !important;
    padding: 0 0.15rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .mobile_left {
    flex: 1;
  }
  .weixin {
    margin: 0;
    width: 0.85rem;
    overflow: hidden;
    .wx-code {
      width: 1.01rem;
    }
    .wx-text {
      width: 0.83rem;
    }
  }
}
</style>
